/**
 * Created by chengpanwang on 2017/3/23.
 */
var Helper = {
  install (Vue) {
    Vue.prototype.$helper = Helper
  },
  isDetail (path) {
    if (!path) {
      return
    }
    return path.endsWith(path, 'detail')
  },
  reset (val) {
    if (!val) {
      return
    }

    if (typeof val === 'string') {
      val = ''
      return val
    }
    if (typeof val === 'number') {
      val = null
      return val
    }
    if (val instanceof Array) {
      for (let i in val) {
        val[i] = this.reset(val[i])
      }
    }
    if (typeof val === 'object') {
      for (let k in val) {
        val[k] = this.reset(val[k])
      }
    }
  },
  copyProperties (src, dest) {
    if (!src || !dest) {
      return
    }
    for (var key of Object.keys(dest)) {
      let v = src[key]
      dest[key] = v
    }
  },
  mergeProperties (src, dest) {
    if (!src || !dest) {
      return
    }
    for (var key of Object.keys(src)) {
      let v = src[key]
      if (v !== undefined && v !== '' && v !== null) {
        dest[key] = v
      }
    }
  },
}

export default Helper



// WEBPACK FOOTER //
// ./src/plugins/Helper.js